import { getCookie } from "cookies-next";
import client from "../client";

export interface UfabetTransferOutRequest {
  amount: number;
}

export interface UfabetTransferOutResponse {
  status?: "success" | "error";
  message?: string;
  data?: {
    member_id?: number;
    ufabet_username?: string;
    amount?: number;
    member_balance?: number;
    ufabet_balance?: number;
    transaction_id?: string;
    ufabet_tx_id?: string;
    transfer_type?: string;
  };
}

/**
 * API สำหรับโยกเงินจาก UFABET กลับเข้าระบบ
 * Route: ufabet/member/transfer-out
 * Method: POST
 * @param request - Object ที่มี amount
 * @returns Promise<UfabetTransferOutResponse>
 *
 * @example
 * const response = await ufabetTransferOut({ amount: 50 });
 * if (response.status === 'success') {
 *   console.log('Transfer completed:', response.data?.transaction_id);
 * }
 */
export default async function ufabetTransferOut(
  request: UfabetTransferOutRequest
): Promise<UfabetTransferOutResponse | undefined> {
  try {
    if (!request.amount || request.amount <= 0) {
      return {
        status: "error",
        message: "จำนวนเงินต้องมากกว่า 0",
      };
    }

    const response = await client.post<UfabetTransferOutResponse>(
      "/ufabet/member/transfer-out",
      {
        amount: request.amount,
      },
      {
        headers: {
          Authorization: `Bearer ${getCookie("access_token")?.toString()}`,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error transferring out from UFABET:", error);
    return {
      status: "error",
      message:
        error.response?.data?.message ||
        "ไม่สามารถโยกเงินได้ กรุณาลองใหม่อีกครั้ง",
    };
  }
}
